import React from 'react';
import { Box, Typography } from '@mui/material';
import { MainContentIcon } from './MainContentIcon';

export const ScheduleInfoGridContainer = ({ gridArea, children }) => {
	return (
		<Box
			sx={{
				'@container course-info (max-width: 768px)': {
					display: 'none'
				},
				display: 'grid',
				gridArea: gridArea,
		}}>
			{children}
		</Box>
	);
};

export const ScheduleHeadlineGridContainer = ({ gridArea, text }) => {
	return (
		<Box
			sx={{
				'@container course-info (max-width: 768px)': {
					display: 'grid'
				},
				display: 'none',
				gridArea: gridArea,
				alignSelf: 'center',
				textAlign: 'start',
				padding: '.5rem 0 .5rem 1rem',
		}}>
			<Typography variant='h5'>{text}</Typography>
		</Box>
	);
};

export const ScheduleIconGridContainer = ({ gridArea, identifier, name }) => {
	return (
		<Box
			sx={{
				'@container course-info (max-width: 768px)': {
					display: 'grid'
				},
				display: 'none',
				gridArea: gridArea,
				pr: '.5rem'
		}}>
			<MainContentIcon identifier={identifier} color='#083163' name={name} size='2rem' />
		</Box>
	);
};

export const ScheduleItemMobileGridContainer = ({ gridArea, children }) => {
	return (
		<Box
			sx={{
				'@container course-info (max-width: 768px)': {
					display: 'grid'
				},
				display: 'none',
				gridArea: gridArea,
				alignSelf: 'center',
				textAlign: 'start',
		}}>
			{children}
		</Box>
	);
};

export const ScheduleItemDesktopGridContainer = ({ gridArea, children }) => {
	return (
		<Box sx={{ '@container course-info (min-width: 768px)': { display: 'grid' }, display: 'none', gridArea: gridArea }}>
			{children}
		</Box>
	);
};